import Vuex from 'vuex'
import Vue from 'vue'
import user from './modules/user'
import listReload from './modules/listReload'
import common from './modules/common'
import location from './modules/location'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        currentType: 0,
        active: 0
    },
    actions: {},
    mutations: {
        xType(state, num) {
            state.currentType = num
        },
        xActive(state, act) {
            state.active = act
        }
    },
    modules: {
        user,
        listReload,
        common,
        location
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js